import React from 'react';

import { Helmet } from 'react-helmet';
import { SubscriptionPlan } from 'src/components/admin/billing/SubscriptionPlan';
import { makeStyles } from 'tss-react/mui';

import { AiUsage } from './AiUsage';

const useStyles = makeStyles()(theme => ({
  wrapper: {
    display: 'flex',
    gap: theme.spacing(2),
    justifyContent: 'center',
    width: '100%',
  },
}));

export function BillingPage(): JSX.Element {
  const { classes } = useStyles();

  return (
    <>
      <Helmet>
        <title>Billing</title>
      </Helmet>
      <div className={classes.wrapper}>
        <SubscriptionPlan />
        <AiUsage />
      </div>
    </>
  );
}
